import React, { FC } from "react";

export const WhiteSuperTalentBadge: FC<JSX.IntrinsicAttributes> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17" {...props}>
      <path
        d="M0.493484 0.785767H4.49696C4.66377 0.785767 4.79931 0.857068 4.90356 0.99967L7.43701 4.72771C5.87315 4.87031 4.54909 5.46109 3.46481 6.50005L0.086881 1.54971C-0.0173762 1.38673 -0.0278019 1.22376 0.0556038 1.06079C0.159861 0.87744 0.305821 0.785767 0.493484 0.785767ZM15.9131 1.54971L12.5352 6.50005C11.4509 5.48146 10.1268 4.89068 8.56299 4.72771L11.0964 0.99967C11.2007 0.857068 11.3362 0.785767 11.503 0.785767H15.5065C15.6942 0.785767 15.8401 0.87744 15.9444 1.06079C16.0278 1.22376 16.0174 1.38673 15.9131 1.54971Z"
        fill="white"
      />
      <path
        d="M13.1422 11.0713C13.1422 13.9116 10.8396 16.2142 7.9993 16.2142C5.15898 16.2142 2.85645 13.9116 2.85645 11.0713C2.85645 8.231 5.15898 5.92847 7.9993 5.92847C10.8396 5.92847 13.1422 8.231 13.1422 11.0713Z"
        fill="white"
      />
    </svg>
  );
};
